<div
  fxLayout="column"
  fxLayoutAlign="space-around center"
  class="interface-container"
  *ngIf="travelModes.length"
>
  <h2>
    {{ 'pages.localisation.interface.title' | translate }}
  </h2>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      *ngFor="let mode of travelModes; let i=index"
      class="control"
      [ngClass]="{'active': mode.travelMode === activeMode}"
      (click)="changeTravelMode(mode)"
    >
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <div
          class="icon-wrapper gradient-background"
        >
          <img
            [src]="mode.iconUrl"
            alt="gmap control icon"
            class="control-icon"
            loading="lazy"
          >
        </div>
        <span
          class="mode-text"
        >
          {{ 'model.gmaps.travel_mode.' + mode.travelMode | translate }}
        </span>
      </div>
      <span
        class="controls-separator"
      >
        {{ 'pages.localisation.interface.or' | translate }}
      </span>
    </div>
  </div>
  <app-location-search-input
    style="width: 100%"
  >
  </app-location-search-input>
  <p
    class="info"
  >
    {{ 'pages.localisation.interface.info' | translate }}
  </p>
  <h3
    fxHide
    fxShow.gt-sm
  >
    {{ 'pages.localisation.interface.more' | translate }}
  </h3>
  <a
    fxHide
    fxShow.gt-sm
    mat-raised-button
    color="main-color"
    [routerLink]="[basePath, 'contacteaza-ne']"
    class="search-link"
  >
    {{ 'pages.localisation.interface.button' | translate }}
  </a>
</div>



// WEBPACK FOOTER //
// ./src/app/localisation/interface.component.html